//IMPORTANT: These methods are for display purposes only .not to be used for date in forms.

export const formatDate = (dateInput?: string) => {
  if (dateInput === null || typeof dateInput === 'undefined') {
    return '';
  } else {
    return new Date(dateInput).toLocaleDateString();
  }
};

export const formatDateTime = (dateTimeInput?: string) => {
  if (dateTimeInput === null || typeof dateTimeInput === 'undefined') {
    return '';
  } else {
    return new Date(dateTimeInput).toLocaleString('en-GB', { hour12: true }); //toLocaleString([], { hour12: true });
  }
};

export const formatTime = (dateTimeInput?: string) => {
  if (dateTimeInput === null || typeof dateTimeInput === 'undefined') {
    return '';
  } else {
    return new Date(dateTimeInput).toLocaleTimeString('en-GB', {
      hour12: true,
    }); //toLocaleString([], { hour12: true });
  }
};

export const formatInputDate = (dateTimeInput?: string) => {
  if (dateTimeInput === null || typeof dateTimeInput === 'undefined') {
    return '';
  } else {
    return dateTimeInput.split('T')[0];
  }
};

export const timeOfDayGreeting = (userName = '') => {
  const hours = new Date().getHours();
  if (hours < 12) {
    return `🌞 Good morning ${userName}!!`;
  } else if (hours < 16) {
    return `☀️ Good afternoon ${userName}!!`;
  } else {
    return `🌙 Good evening ${userName}!!`;
  }
};

export const formatDisplayDate = (dateString?: string) => {
  let date = new Date().toLocaleDateString('en-us', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    weekday: 'short',
  });

  if (dateString !== undefined) {
    date = new Date(dateString).toLocaleDateString('en-us', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
    });
  }

  return date;
};
export const formatDisplayDateTime = (dateString?: string) => {
  let date = new Date().toLocaleTimeString('en-us', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });

  if (dateString !== undefined) {
    date = new Date(dateString).toLocaleTimeString('en-us', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });
  }

  return date;
};
